import { MultimediaFileDTO } from "./multimediaFileDTO";

export interface PlaylistDTO {
  id: string;
  name: string;
  createdBy: string;
  createdOn: string;
  lastModification: string;
  multimediaFiles: MultimediaFileDTO[];
  version: number;
}

export enum FileOperationStatus {
  VALIDATION_ERROR = "VALIDATION_ERROR",
  WAITING_FOR_CONVERSION = "WAITING_FOR_CONVERSION",
  CONVERSION_ERROR = "CONVERSION_ERROR",
  CONVERSION_DONE = "CONVERSION_DONE",
}
